export class CashAmountInput {
  private static readonly MAX_DIGITS_BEFORE_COMMA = 6;
  private static readonly MAX_DECIMALS = 2;

  private constructor(
    private readonly _value: string = '0',
    private readonly _isFirst: boolean = true
  ) {
  }

  get displayValue(): string {
    return this._value;
  }

  get amount(): number {
    return parseFloat(this._value.replace(',', '.')) || 0;
  }

  static empty(): CashAmountInput {
    return new CashAmountInput('0', true);
  }

  append(char: string): CashAmountInput {
    if (this._isFirst) {
      return new CashAmountInput(char === '0' ? '0' : char, false);
    }

    if (this._value === '0' && char !== '0') {
      return new CashAmountInput(char, false);
    }

    if (this.reachesLimit(this._value + char)) {
      return this;
    }

    return new CashAmountInput(this._value + char, false);
  }

  appendComma(): CashAmountInput {
    if (this._value.includes(',')) {
      return this;
    }

    return new CashAmountInput(this._value + ',', false);
  }

  removeLast(): CashAmountInput {
    if (this._value.length <= 1) {
      return CashAmountInput.empty();
    }

    return new CashAmountInput(this._value.slice(0, -1), false);
  }

  private reachesLimit(val: string): boolean {
    const [integers, decimals] = val.split(',');

    if (decimals !== undefined && decimals.length > CashAmountInput.MAX_DECIMALS) {
      return true;
    }

    return integers.length > CashAmountInput.MAX_DIGITS_BEFORE_COMMA;
  }
}
